module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/android11Logo.2f9ac5b8.gif";